import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import GetGatheringForLabelsDocument from "src/api/graphql/__generated__/documents/GetGatheringForLabelsDocument";
import GatheringAccessEnum from "src/api/graphql/__generated__/enums/GatheringAccessEnum";
import LabelVisibility from "src/api/graphql/__generated__/enums/LabelVisibility";
import useGatheringFilterSortRefreshListener from "../../useGatheringFilterSortRefreshListener";

const useGatheringLabelsData = (gatheringId: string) => {
	const { data: gatheringLabelsData, refetch: gatheringLabelsRefetch } = useQuery(
		GetGatheringForLabelsDocument,
		{
			variables: {
				input: {
					gatheringId,
				},
			},
			fetchPolicy: "cache-and-network",
		},
	);
	const { data: adminGatheringLabelsData, refetch: adminGatheringLabelsRefetch } = useQuery(
		GetGatheringForLabelsDocument,
		{
			variables: {
				input: {
					gatheringId,
				},
				labelsInput: {
					visibility: LabelVisibility.Admin,
				},
			},
			fetchPolicy: "cache-and-network",
			skip: gatheringLabelsData?.getGathering?.access !== GatheringAccessEnum.Admin,
		},
	);

	useGatheringFilterSortRefreshListener(async () => {
		await Promise.all([gatheringLabelsRefetch(), adminGatheringLabelsRefetch()]);
	});

	return useMemo(() => {
		return {
			publicLabelsData: (gatheringLabelsData?.getGathering?.labels?.payload ?? []).map(
				(label) => ({
					label: label.label,
					numPhotos: label.numPhotos ?? 0,
				}),
			),
			adminLabelsData: (adminGatheringLabelsData?.getGathering?.labels?.payload ?? []).map(
				(label) => ({
					label: label.label,
					numPhotos: label.numPhotos ?? 0,
				}),
			),
		};
	}, [gatheringLabelsData, adminGatheringLabelsData]);
};
export default useGatheringLabelsData;
